<template>
    <div class="AlgoliaSearchContainer">
        <ais-configure v-bind="searchParameters" :hits-per-page.camel="21" />
        <AlgoliaSearchHeader
            :image="image"
            :ratio="ratio"
            @update="updateSearchParams"
        />
        <AlgoliaSearchCategories
            :attributes="[
                'categories.lvl0',
                'categories.lvl1'
            ]"
            :total-count.sync="totalCount"
        >
        </AlgoliaSearchCategories>

        <div class="container">
            <AlgoliaFeatureFilters attribute="productFeatures" />
            <div class="py-medium flex-center-b">
                <ais-stats>
                    <strong
                        slot-scope="{ nbHits }"
                        class="smaller text--grey-dark"
                    >
                        {{ nbHits }} results
                    </strong>
                </ais-stats>
                <AlgoliaSearchClear
                    :excluded-attributes="[]"
                    @resetLocations="resetLocations"
                >
                    <strong
                        class="smaller text--blue mr-min"
                    >
                        Clear Filters
                    </strong>
                    <BaseIcon
                        icon="reset"
                        class="text--redpink"
                    />
                </AlgoliaSearchClear>
            </div>
            <ais-infinite-hits :transform-items="transformItems">
                <div slot-scope="{ items, refineNext, isLastPage }">
                    <ul class="AlgoliaHits grid grid--medium">
                        <li
                            v-for="item in items"
                            :key="item.id"
                            class="grid__item smart-one-whole one-half desk-one-third"
                        >
                            <AlgoliaSearchHit :item="item" />
                        </li>
                    </ul>
                    <HrLine v-if="!isLastPage" />
                    <AlgoliaSearchLoadMore
                        class="AlgoliaSearchLoadMore"
                        v-if="!isLastPage"
                        @refine="refineNext"
                    />
                </div>
            </ais-infinite-hits>
        </div>
    </div>
</template>
<script>
// Import the EventBus.
import { EventBus } from '@utils/event-bus.js';

export default {
    name: 'AlgoliaSearchContainer',
    props: {
        image: {
            type: String
        },
        ratio: {
            type: Number
        }
    },
    data() {
        return {
            totalCount: '',
            searchParameters: []
        }
    },
    methods: {
        transformItems(items) {
            return items.filter((item) => item['categories.lvl0'].indexOf('Events') === -1);
        },

        updateSearchParams(value) {
            this.searchParameters = value;
        },

        resetLocations() {
            EventBus.$emit('resetLocations', { towns: [], surrounding: false });
        }
    },
}
</script>
<style lang="scss" scoped>
    .BaseButton {
        display: block!important;
        margin: auto;
        cursor: pointer;
        margin-bottom: getSpacing(large);
    }

    .HrLine {
        margin-bottom: getSpacing(large);
        padding: 0;
    }

    .BaseIcon {
        position: relative;
        top: 2px;
    }

    ::v-deep .ais-ClearRefinements-button {
        color: getColor('white');
        font-size: 15px;
        background: transparent;

        @include media-query(lap-and-up) {
            border-radius: 50px;
            padding: 6px 15px;
        }

        .circle {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 1rem;
            border: 2px solid getColor('lightblue');

            @include media-query(lap-and-up) {
                display: none;
            }
        }

        @include media-query(palm) {
            width: 100%;
            padding: 1rem 1.5rem;
            border-bottom: 1px solid rgba(getColor('white'), 0.4);

            > span {
                display: flex;
                align-items: center;
            }
        }

        &.ais-ClearRefinements-button--disabled {
            @include media-query(lap-and-up) {
                background: getColor('lightblue');
            }
        }
    }
</style>
